import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { TrialDescriptionModalMobileProps } from './TrialDescriptionModalMobile';

export const renderTrialDescriptionModalMobile = (data: TrialDescriptionModalMobileProps) =>
    openPopupHelper({ popupName: popupNames.TRIAL_DESCRIPTION_MODAL_MOBILE, data });

export const closeTrialDescriptionModalMobile = () => closePopupHelper(popupNames.TRIAL_DESCRIPTION_MODAL_MOBILE);
